import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { createVoice, getAgencyVoices, getBusinessVoices } from './api';
import { VoiceMetaResponse, VoiceResponse } from './types';
import { useParams } from 'react-router-dom';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function useGetBusinessVoices(
  options?: UseQueryOptions<{ data: VoiceResponse[]; meta: VoiceMetaResponse }, Error>
) {
  const { workspaceId, agentId } = useParams<{
    workspaceId: string;
    agentId: string;
  }>();
  return useQuery<{ data: VoiceResponse[]; meta: VoiceMetaResponse }>({
    queryKey: ['voices', workspaceId, agentId],
    queryFn: () => getBusinessVoices(workspaceId, agentId),
    ...options
  });
}

export function useCreateVoice() {
  const { workspaceId, agentId } = useParams<{
    workspaceId: string;
    agentId: string;
  }>();
  return useMutation({
    mutationFn: (payload: FormData) => createVoice(workspaceId, agentId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['voices'],
        refetchType: 'active'
      });
    }
  });
}

export function useGetAgencyVoices(options?: UseQueryOptions<{ data: VoiceResponse[]; meta: MetaApiResponse }, Error>) {
  return useQuery<{ data: VoiceResponse[]; meta: MetaApiResponse }>({
    queryKey: ['agentVoices'],
    queryFn: () => getAgencyVoices(),
    ...options
  });
}
